import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	linkCardsMacroTitle: {
		id: 'company-hub.cards-extension.manifest.macro-title',
		defaultMessage: 'Cards',
		description: 'Title of link cards macro to be displayed in toolbar/shortcut macros dropdown.',
	},
	linkCardsMacroDescription: {
		id: 'company-hub.cards-extension.manifest.macro-description',
		defaultMessage: 'Display links as cards',
		description:
			'Description of link cards macro to be displayed in toolbar/shortcut macros dropdown',
	},
});
